export default __webpack_public_path__ + "static/media/hospital-img-2.ae92458d.png";